import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <main>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <span className="hero-badge">India's Semiconductor Future</span>
          <h1>Precision Silicon Wafers for a <span>Smarter India</span></h1>
          <p>
            Seminexis Pvt Ltd is a global distributor of high-quality silicon wafers,
            serving the semiconductor and advanced electronics industries with precision-engineered
            materials that meet the highest standards.
          </p>
          <div className="hero-cta">
            <Link to="/products" className="btn-primary">Explore Products</Link>
            <Link to="/contact" className="btn-secondary">Get in Touch</Link>
          </div>
        </div>
        <div className="hero-image">
          <div className="wafer-visual">
            <div className="wafer-circle">
              <div className="wafer-inner">
                <span>Silicon Wafer</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Snippet */}
      <section className="home-about">
        <div className="home-about-inner">
          <div className="about-card">
            <div className="about-icon">🔬</div>
            <h3>Precision Materials</h3>
            <p>Wafers engineered to the highest purity and performance standards for cutting-edge chip development.</p>
          </div>
          <div className="about-card">
            <div className="about-icon">🌐</div>
            <h3>Global Sourcing</h3>
            <p>Connecting global wafer manufacturers with India's growing demand for advanced semiconductor materials.</p>
          </div>
          <div className="about-card">
            <div className="about-icon">🤝</div>
            <h3>Collaborative Partner</h3>
            <p>More than a supplier — a trusted partner for fabs, R&D labs, and innovators shaping India's tech future.</p>
          </div>
        </div>
      </section>

      {/* Meet the Founder */}
      <section className="founder-section">
        <div className="founder-inner">
          <div className="founder-photo">
            <div className="photo-placeholder">
              <span>D</span>
            </div>
          </div>
          <div className="founder-info">
            <span className="section-label">Meet Our Founder</span>
            <h2>Darshan Pawar</h2>
            <p>
              I founded Seminexis Pvt Ltd with a clear vision to contribute meaningfully to India's
              semiconductor revolution. As the country invests in new fabs, advanced packaging
              facilities, and cutting-edge research, I felt a strong responsibility to be part of
              this historic transformation.
            </p>
            <p>
              My goal is to strengthen one of the most critical pillars of the ecosystem by ensuring
              reliable access to high-quality silicon wafers for companies across India.
            </p>
            <Link to="/about" className="btn-primary" style={{ marginTop: '20px', display: 'inline-block' }}>
              Read Full Story
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Snippet */}
      <section className="home-contact">
        <div className="home-contact-inner">
          <h2>Ready to work together?</h2>
          <p>Reach out to discuss your silicon wafer requirements.</p>
          <div className="contact-details">
            <span>📧 darshanpawar18@gmail.com</span>
            <span>📞 269-276-6645</span>
          </div>
          <Link to="/contact" className="btn-primary">Get in Touch</Link>
        </div>
      </section>
    </main>
  );
}

export default Home;
